export const escapeRegExp = (string) => {
  return string.replace(/[.*+?^${}()|[\\]\\$]/g, '\\$&')
}

export const highlightMatches = (text, query) => {
  if (!query) return text
  
  const escapedQuery = escapeRegExp(query)
  const regex = new RegExp(`(${escapedQuery})`, 'gi')
  return text.replace(regex, '<mark class="bg-yellow-200 dark:bg-yellow-600 text-gray-900 dark:text-gray-100 px-1 py-0.5 rounded font-medium">$1</mark>')
}